import React from 'react';
import { useTheme } from 'styled-components';
import PropTypes from 'prop-types';

import { Text, Box } from 'Components/Base';

const FeedbackButtonOption = ({ label, checked, ...props }) => {
  const { colors } = useTheme();
  return (
    <Box
      role="button"
      width={1}
      bg={checked ? 'primary' : '#F9FBFF'}
      style={{ border: `solid 1px ${colors.primary}`, borderRadius: '50px' }}
      {...props}
    >
      <Text
        textStyle={'body2'}
        fontWeight={'normal'}
        py={2}
        px={4}
        color={checked ? 'white' : 'text'}
      >
        {label}
      </Text>
    </Box>
  );
};

FeedbackButtonOption.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
};

export default FeedbackButtonOption;
